// Fond animé discret : braises qui montent (canvas ou CSS), respecte prefers-reduced-motion.
import { useEffect, useState } from "preact/hooks";
import "./Embers.css";

const COUNT = 22;
const REDUCED_QUERY = "(prefers-reduced-motion: reduce)";
const COLORS = ["var(--ember)", "var(--ember-2)", "var(--gold)"];

/** Bruit déterministe dans [0, 1) : même décor à chaque affichage, sans Math.random. */
function noise(index: number, salt: number): number {
  let h = Math.imul(index + 1, 0x9e3779b1) ^ Math.imul(salt + 1, 0x85ebca6b);
  h = Math.imul(h ^ (h >>> 16), 0x7feb352d);
  h = Math.imul(h ^ (h >>> 15), 0x846ca68b);
  return ((h ^ (h >>> 16)) >>> 0) / 4294967296;
}

function emberStyle(i: number): string {
  const depth = noise(i, 1);                                    // 0 = loin (petite, lente, pâle), 1 = proche
  const size = 2 + depth * 4.5;                                 // px
  const duration = 16 - depth * 7 + noise(i, 2) * 3;            // s
  const delay = -noise(i, 3) * duration;                        // déjà en route au chargement
  const left = ((i * 0.618034 + noise(i, 4) * 0.08) % 1) * 100; // répartition régulière (nombre d'or)
  const drift = (noise(i, 5) * 2 - 1) * 64;                     // dérive latérale, px
  const peak = 0.35 + depth * 0.5;
  const color = COLORS[Math.floor(noise(i, 6) * COLORS.length)];
  return [
    `left:${left.toFixed(2)}%`,
    `--ember-size:${size.toFixed(2)}px`,
    `--ember-dur:${duration.toFixed(2)}s`,
    `--ember-delay:${delay.toFixed(2)}s`,
    `--ember-drift:${drift.toFixed(1)}px`,
    `--ember-peak:${peak.toFixed(2)}`,
    `--ember-color:${color}`,
  ].join(";");
}

const EMBER_STYLES: string[] = Array.from({ length: COUNT }, (_, i) => emberStyle(i));

function reducedMotionQuery(): MediaQueryList | null {
  try {
    return typeof window !== "undefined" && typeof window.matchMedia === "function"
      ? window.matchMedia(REDUCED_QUERY)
      : null;
  } catch {
    return null;
  }
}

function usePrefersReducedMotion(): boolean {
  const [reduce, setReduce] = useState(() => reducedMotionQuery()?.matches ?? false);
  useEffect(() => {
    const mq = reducedMotionQuery();
    if (!mq) return;
    const onChange = () => setReduce(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  return reduce;
}

export function Embers() {
  const reduce = usePrefersReducedMotion();
  if (reduce) return null;
  return (
    <div class="embers" aria-hidden="true">
      {EMBER_STYLES.map((style, i) => (
        <div key={i} class="embers-ember" style={style} />
      ))}
    </div>
  );
}
